import { Anteproy_condominio } from './../../../models/anteproy_condominio.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-anteproy_condominio",
    templateUrl: "./anteproy_condominio.component.html",
    styleUrls: ["./anteproy_condominio.component.css"],
    providers: [FormService]
})

export class Anteproy_condominioComponent {

    public rows = [];
    public actualRow;
    public anteproy_condominio: Anteproy_condominio;
    public form;
 
    matcher = new FormService();

    constructor(){
        this.form = new FormGroup({
            superficie: new FormControl(''),
            cantidad: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("anteproy_condominio"))){
            localStorage.setItem("anteproy_condominio", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("anteproy_condominio"));

            this.form.controls['superficie'].setValue(this.rows[0]?this.rows[0].superficie:'')
            this.form.controls['cantidad'].setValue(this.rows[0]?this.rows[0].cantidad:'')
            
        }

    }

    add_anteproy_condominio(){
        localStorage.setItem("anteproy_condominio",JSON.stringify([]));
        this.actualRow = localStorage.getItem("anteproy_condominio");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            superficie: this.form.value.superficie,
            cantidad: this.form.value.cantidad
        })
        localStorage.setItem("anteproy_condominio", JSON.stringify(this.rows));
    }
  
    delete_anteproy_condominio(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("anteproy_condominio", JSON.stringify(this.rows));
            }
        }
    }  
}